<template>
  <template v-if="detail == false">
    <div class="row mx-0 px-1" style="min-width: 80rem">
      <div class="col-12 text-end px-0 my-2">
        <span class="my-0" id="mes-update-time">更新時間:</span>
        <span class="my-0" for="mes-update-time">{{ nowTime }}</span>
      </div>
      <div class="col-12 px-0">
        <div class="row mx-0">
          <div class="col-12 p-2 pb-0" style="background-color: #f2f2f2">
            <div style="
                background-color: var(--main-font-color);
                position: relative;
              " :style="{
                height: mapSize.clientHeight + 'px',
                'min-height': mapSize.clientHeight + 'px',
              }">
              <div style="
                  position: absolute;
                  left: 0;
                  width: 100%;
                  background-color: var(--main-font-color);
                  overflow: hidden;
                " :style="{ height: mapSize.clientHeight + 'px' }">
                <template v-if="siteArea != null">
                  <div v-for="(item, key) in eboard_device_site" :key="key" :style="{
                    top:
                      item.style.top *
                      (mapSize.clientHeight / item.mapHeight) +
                      'px',
                    left:
                      item.style.left *
                      (mapSize.clientWidth / item.mapWidth) +
                      'px',
                    width:
                      item.style.width *
                      (mapSize.clientWidth / item.mapWidth) +
                      'px',
                    height:
                      item.style.height *
                      (mapSize.clientHeight / item.mapHeight) +
                      'px',
                    'background-color': item.color,
                    'border-radius': item.shape == 'circle' ? '50%' : '',
                  }" style="
                      position: absolute;
                      cursor: pointer;
                      text-align: center;
                    " class="p-0">
                    <template v-if="item.label">
                      <div style="
                          font-size: 1rem;
                          text-align: left;
                          padding-left: 8px;
                          overflow: hidden;
                        " :style="{
                          width:
                            item.style.width *
                            (mapSize.clientWidth / item.mapWidth) +
                            'px',
                          'line-height':
                            item.style.height *
                            (mapSize.clientHeight / item.mapHeight) +
                            'px',
                        }">
                        {{ item.label }}
                      </div>
                    </template>
                    <div v-if="item.shape == 'poly'" :style="{
                      top:
                        item.style.polyTop *
                        (mapSize.clientHeight / item.mapHeight) +
                        'px',
                      left:
                        item.style.polyLeft *
                        (mapSize.clientWidth / item.mapWidth) +
                        'px',
                      width:
                        item.style.polyWidth *
                        (mapSize.clientWidth / item.mapWidth) +
                        'px',
                      height:
                        item.style.polyHeight *
                        (mapSize.clientHeight / item.mapHeight) +
                        'px',
                      'background-color': item.color,
                    }" style="position: relative; cursor: pointer"></div>
                  </div>
                </template>
              </div>
              <div style="position: absolute; width: 100%; left: 0">
                <img :src="eboardSite" ref="homeMap" alt="" style="
                    width: 100%;
                    height: 100%;
                    left: 0px;
                    object-fit: contain;
                  " />
              </div>
              <div style="
                  left: 0;
                  position: absolute;
                  width: 100%;
                  overflow: hidden;
                " :style="{
                  height: mapSize.clientHeight + 'px',
                }">
                <template v-if="siteArea != null">
                  <div v-for="(item, key) in eboard_device_site" :key="key" :style="{
                    top:
                      item.style.top *
                      (mapSize.clientHeight / item.mapHeight) +
                      'px',
                    left:
                      item.style.left *
                      (mapSize.clientWidth / item.mapWidth) +
                      'px',
                    width:
                      item.style.width *
                      (mapSize.clientWidth / item.mapWidth) +
                      'px',
                    height:
                      item.style.height *
                      (mapSize.clientHeight / item.mapHeight) +
                      'px',
                    'border-radius': item.shape == 'circle' ? '50%' : '',
                  }" style="
                      position: absolute;
                      cursor: pointer;
                      background-color: transparent;
                    " data-bs-toggle="popover" data-bs-trigger="hover focus" data-bs-placement="top"
                    data-bs-custom-class="home-popover" :data-bs-content="item.message == null ? '' : item.message"
                    @click="
                      changPage(
                        item.site,
                        item.siteName,
                        item.oper,
                        item.operName,
                        item.device_name
                      )
                      " :id="item.deviceName + '-mes-home'" @mouseover="setPopover(item.deviceName + '-mes-home')"
                    @mouseleave="killPopover(item.deviceName + '-mes-home')">
                    <div v-if="item.shape == 'poly'" :style="{
                      top:
                        item.style.polyTop *
                        (mapSize.clientHeight / item.mapHeight) +
                        'px',
                      left:
                        item.style.polyLeft *
                        (mapSize.clientWidth / item.mapWidth) +
                        'px',
                      width:
                        item.style.polyWidth *
                        (mapSize.clientWidth / item.mapWidth) +
                        'px',
                      height:
                        item.style.polyHeight *
                        (mapSize.clientHeight / item.mapHeight) +
                        'px',
                    }" style="
                        position: relative;
                        cursor: pointer;
                        background-color: transparent;
                      "></div>
                  </div>
                </template>
              </div>
            </div>
            <div v-if="canManageAuditMode" class="text-center my-1">
              <div class="form-check form-switch d-inline-block me-3">
                <input class="form-check-input" type="checkbox" role="switch" id="auditModeSite1"
                  :checked="auditModeFlags.site1" @change="toggleAuditMode('site1')" />
                <label class="form-check-label" for="auditModeSite1">岡山廠稽核模式</label>
              </div>
              <div class="form-check form-switch d-inline-block">
                <input class="form-check-input" type="checkbox" role="switch" id="auditModeSite2"
                  :checked="auditModeFlags.site2" @change="toggleAuditMode('site2')" />
                <label class="form-check-label" for="auditModeSite2">梓官廠稽核模式</label>
              </div>
            </div>
            <div class="text-center my-1">
              <template v-for="(value, status) in deviceStatus" :keys="status">
                <span class="pe-2 mb-2">
                  <font-awesome-icon :icon="['fas', 'square']" :style="{
                    color: value.color,
                  }" />
                  {{ value.text }}
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <template v-else-if="detail == true">
    <!-- 機台明細 -->
    <machStatus></machStatus>
  </template>
</template>

<script>
import { useStore } from "vuex";
import {
  computed,
  inject,
  onMounted,
  onUnmounted,
  provide,
  ref,
  watch,
} from "@vue/runtime-core";
import { Popover } from "bootstrap";
import machStatus from "@/components/machStatus.vue";
export default {
  name: "Index-home",
  components: { machStatus },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideBarSelect = computed(
      () => store.getters["sideBarTree/get_sideBarSelect"]
    );
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const sideBar = computed(() => store.getters["sideBarTree/get_sideBar"]);
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const timeOutId = computed(
      () => store.getters["commonAlert/get_timeOutId"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
    };

    const path = inject("path");
    const sideNavTrigger = inject("sideNavTrigger");

    const nowTime = ref("-");
    const mapSize = ref({
      clientWidth: 0,
      clientHeight: 0,
    });
    const homeMap = ref(null);
    const siteArea = ref();
    const site = ref();
    const detail = ref();
    const siteName = ref();
    const oper = ref();
    const operName = ref();
    const deviceName = ref();
    const eboardSite = ref("");
    // const eboardFactory = require("@/assets/eboard-factory-new.png");
    // const eboard_device_factory_one_default = ref([
    //   {
    //     deviceName: "退火12",
    //     message: "退火12，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 76,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 23,
    //       left: 27,
    //       width: 693,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heat-treatment1",
    //     groupName: "熱一組",
    //   },
    //   {
    //     deviceName: "退火11",
    //     message: "退火11，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 135,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 116,
    //       left: 27,
    //       width: 693,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heat-treatment1",
    //     groupName: "熱一組",
    //   },
    //   {
    //     deviceName: "退火10",
    //     message: "退火10，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 193,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 209,
    //       left: 27,
    //       width: 693,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heat-treatment1",
    //     groupName: "熱一組",
    //   },
    //   {
    //     deviceName: "退火9",
    //     message: "退火9，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 251,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 302,
    //       left: 27,
    //       width: 693,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heat-treatment1",
    //     groupName: "熱一組",
    //   },
    //   {
    //     deviceName: "退火8",
    //     message: "退火8，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 309,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 394,
    //       left: 27,
    //       width: 693,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heat-treatment1",
    //     groupName: "熱一組",
    //   },
    //   {
    //     deviceName: "退火7",
    //     message: "退火7，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 367,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 23,
    //       left: 1507,
    //       width: 343,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading1",
    //   },
    //   {
    //     deviceName: "退火6",
    //     message: "退火6，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 515,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 112,
    //       left: 1017,
    //       width: 98,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "thread-rolling1",
    //   },
    //   {
    //     deviceName: "退火5",
    //     message: "退火5，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 573,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 112,
    //       left: 1139,
    //       width: 98,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "thread-rolling1",
    //   },
    //   {
    //     deviceName: "退火4",
    //     message: "退火4，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 631,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 112,
    //       left: 1260,
    //       width: 98,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "thread-rolling1",
    //   },
    //   {
    //     deviceName: "退火3",
    //     message: "退火3，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 689,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 112,
    //       left: 1507,
    //       width: 343,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading1",
    //   },
    //   {
    //     deviceName: "退火2",
    //     message: "退火2，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 745,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 200,
    //       left: 772,
    //       width: 343,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading2",
    //   },
    //   {
    //     deviceName: "退火1",
    //     message: "退火1，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 805,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 200,
    //       left: 1139,
    //       width: 343,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading1",
    //   },
    //   {
    //     deviceName: "加熱5",
    //     message: "加熱5，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 863,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 200,
    //       left: 1507,
    //       width: 343,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading1",
    //   },
    //   {
    //     deviceName: "加熱4",
    //     message: "加熱4，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 921,
    //       width: 49,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 288,
    //       left: 772,
    //       width: 343,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading1",
    //   },
    //   {
    //     deviceName: "加熱2",
    //     message: "加熱2，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 1060,
    //       width: 60,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 288,
    //       left: 1139,
    //       width: 343,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading1",
    //   },
    //   {
    //     deviceName: "加熱1",
    //     message: "加熱1，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 1130,
    //       width: 60,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 288,
    //       left: 1507,
    //       width: 343,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading1",
    //   },
    //   {
    //     deviceName: "保溫3",
    //     message: "保溫3，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 1456,
    //       width: 90,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 419,
    //       left: 772,
    //       width: 343,
    //       height: 64,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading2",
    //   },
    //   {
    //     deviceName: "保溫2",
    //     message: "保溫2，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 1556,
    //       width: 90,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 377,
    //       left: 1144,
    //       width: 80,
    //       height: 104,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading2",
    //   },
    //   {
    //     deviceName: "保溫1",
    //     message: "保溫1，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 1656,
    //       width: 90,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 377,
    //       left: 1234,
    //       width: 80,
    //       height: 104,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading2",
    //   },
    //   {
    //     deviceName: "保溫4",
    //     message: "保溫4，2023-05-05 10:27:27",
    //     style: {
    //       top: 60,
    //       left: 1756,
    //       width: 90,
    //       height: 116,
    //     },
    //     style_single: {
    //       top: 377,
    //       left: 1324,
    //       width: 80,
    //       height: 104,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading2",
    //   },
    //   {
    //     deviceName: "淬水槽2",
    //     message: "淬水槽2，2023-05-05 10:27:27",
    //     style: {
    //       top: 324,
    //       left: 327,
    //       width: 152,
    //       height: 69,
    //     },
    //     style_single: {
    //       top: 377,
    //       left: 1414,
    //       width: 80,
    //       height: 104,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading2",
    //   },
    //   {
    //     deviceName: "淬水槽1",
    //     message: "淬水槽1，2023-05-05 10:27:27",
    //     style: {
    //       top: 397,
    //       left: 590,
    //       width: 133,
    //       height: 106,
    //     },
    //     style_single: {
    //       top: 377,
    //       left: 1503,
    //       width: 80,
    //       height: 104,
    //     },
    //     shape: "rect",
    //     color: "#cccccc",
    //     group: "heading2",
    //   },
    //   {
    //     deviceName: "熱切機",
    //     message: "熱切機，2023-05-05 10:27:27",
    //     style: {
    //       top: 282,
    //       left: 590,
    //       width: 133,
    //       height: 115,
    //       polyTop: 41,
    //       polyLeft: 0,
    //       polyWidth: 319,
    //       polyHeight: 75,
    //     },
    //     style_single: {
    //       top: 377,
    //       left: 1593,
    //       width: 80,
    //       height: 104,
    //     },
    //     shape: "poly",
    //     color: "#cccccc",
    //     group: "heading2",
    //   },
    //   {
    //     deviceName: "鍛造機RF70",
    //     message: "鍛造機RF70，2023-05-05 10:27:27",
    //     style: {
    //       top: 282,
    //       left: 1107,
    //       width: 84,
    //       height: 135,
    //       polyTop: 41,
    //       polyLeft: -180,
    //       polyWidth: 449,
    //       polyHeight: 49,
    //     },
    //     style_single: {
    //       top: 377,
    //       left: 1683,
    //       width: 80,
    //       height: 104,
    //     },
    //     shape: "poly",
    //     color: "#cccccc",
    //     group: "heading2",
    //   },
    //   {
    //     deviceName: "環形爐3",
    //     message: "環形爐3，2023-05-05 10:27:27",
    //     style: {
    //       top: 230,
    //       left: 1408,
    //       width: 240,
    //       height: 240,
    //     },
    //     style_single: {
    //       top: 507,
    //       left: 37,
    //       width: 98,
    //       height: 64,
    //     },
    //     shape: "circle",
    //     color: "#cccccc",
    //     group: "thread-rolling1",
    //   },
    // ]);
    // const eboard_device_factory_two_default = ref([]);
    const eboard_device_site = ref();
    const popoverObj = ref({});
    const queryCounter = ref(0);
    //稽核模式：以現有「permissionsetting」頁面存取權當作管理者代理指標
    const canManageAuditMode = computed(() => {
      return (
        sideBar.value != null &&
        Object.prototype.hasOwnProperty.call(sideBar.value, "permissionsetting")
      );
    });
    const auditModeFlags = ref({ site1: false, site2: false });
    const deviceStatus = {
      R: { color: "#00ff00", text: "運作" },
      Q: { color: "var(--main-status-warning-color)", text: "待機" },
      H: { color: "var(--main-status-danger-color)", text: "異常" },
      "E/M": { color: "var(--main-status-maintain-color)", text: "維修/保養" },
      "A/C/D": {
        color: "var(--main-status-shunting-color)",
        text: "校驗/換模/調車",
      },
      I: { color: "var(--main-status-short-color)", text: "短寸" },
      S: { color: "var(--main-status-stop-color)", text: "離線" },
    };

    //function
    //更新地圖尺寸
    const homeMapSize = (size) => {
      if (size == undefined) {
        return;
      }
      if (size.width != undefined) {
        mapSize.value.clientWidth = size.width;
      }
      if (size.height != undefined) {
        mapSize.value.clientHeight = size.height;
      }
    };
    //總覽切換至明細
    const changPage = (
      selectSite,
      selectSiteName,
      selectOper,
      selectOperName,
      selectDeviceName
    ) => {
      if (
        selectSite == null ||
        selectSiteName == null ||
        selectOper == null ||
        selectOperName == null ||
        selectDeviceName == null
      ) {
        console.log(
          selectSite,
          selectSiteName,
          selectOper,
          selectOperName,
          selectDeviceName
        );
        return;
      }
      console.log(selectSiteName, selectOper, selectOperName, selectDeviceName);
      site.value = selectSite;
      siteName.value = selectSiteName;
      oper.value = selectOper;
      operName.value = selectOperName;
      deviceName.value = selectDeviceName;
      detail.value = true;
    };
    //初始化即時數據
    const initRealData = () => {
      // eboard_device_factory_one.value = JSON.parse(
      //   JSON.stringify(eboard_device_factory_one_default.value)
      // );
      // eboard_device_factory_two.value = JSON.parse(
      //   JSON.stringify(eboard_device_factory_two_default.value)
      // );
    };

    const setSessionItems = () => {
      sessionStorage.setItem("mes-home-detail", detail.value);
      sessionStorage.setItem("mes-home-siteArea", siteArea.value);
      sessionStorage.setItem("mes-home-site", site.value);
      sessionStorage.setItem("mes-home-siteName", siteName.value);
      sessionStorage.setItem("mes-home-oper", oper.value);
      sessionStorage.setItem("mes-home-operName", operName.value);
      sessionStorage.setItem("mes-home-deviceName", deviceName.value);
    };
    window.addEventListener("beforeunload", setSessionItems);
    // factory->site
    const getNowTime = () => {
      let Today = new Date();
      nowTime.value =
        Today.getFullYear() +
        "-" +
        String(Today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(Today.getDate()).padStart(2, "0") +
        " " +
        String(Today.getHours()).padStart(2, "0") +
        ":" +
        String(Today.getMinutes()).padStart(2, "0") +
        ":" +
        String(Today.getSeconds()).padStart(2, "0");
    };
    const clearTimer = () => {
      var highestIntervalId = setInterval(";");
      for (var i = 0; i < highestIntervalId; i++) {
        if (i == timeOutId.value) {
          continue;
        }
        //清除所有計時資料
        clearInterval(i);
      }
    };
    const appendTimestampToUrl = (url) => {
      const timestamp = new Date().getTime(); // 獲取當前時間戳
      const separator = url.includes("?") ? "&" : "?"; // 確保URL中有正確的分隔符

      return url + separator + "v=" + timestamp; // 將時間戳附加到URL的查詢參數中
    };

    // 更新場域圖上的資料
    const updateMapData = (resultData) => {
      let area = resultData.image_name.split(".")[0];
      console.log(resultData.image_name);
      eboardSite.value = appendTimestampToUrl(
        "/static/image/" + resultData.image_name
      );

      let eboard_device_site_data = [];
      resultData.device_data.forEach((data) => {
        eboard_device_site_data.push({
          deviceName: data.deviceName,
          style: {
            top: data[area].top,
            left: data[area].left,
            width: data[area].width,
            height: data[area].height,
          },
          mapWidth: data.image_weight,
          mapHeight: data.image_height,
          shape: data.shape,
          color: "var(--main-status-stop-color)",
        });
      });
      eboard_device_site.value = eboard_device_site_data;
      getSiteData();
      // 延遲更新點座標，以便適應圖片大小
      setTimeout(() => {
        homeMapSize(homeMap.value);
      }, 500);
    };
    // 取得場域的圖片、機台資料
    const getSiteMapData = () => {
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "QueryDeviceArea";
      params["area"] = params["webPage"];

      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let queryTableData = result.QueryTableData;
          updateMapData(queryTableData);
        }
      });
    };
    //取得全場機台資料
    const getSiteData = () => {
      clearTimer();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      params["methods"] = "GET";
      params["whichFunction"] = "MainQuery";
      params["site"] = siteArea.value;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (path.value != result.page) {
          return;
        }
        console.log(path.value);
        if (siteArea.value != result.QueryData.site) {
          return;
        }

        let result_data = result["QueryTableData"][0];
        if (result_data["all_device_data"] != undefined) {
          let all_device_data = result_data["all_device_data"];
          let package_data = result_data["package_data"];
          let container_data = result_data["container_data"];
          eboard_device_site.value.forEach((data, index) => {
            if (
              all_device_data[data.deviceName] == undefined &&
              package_data[data.deviceName] == undefined &&
              container_data[data.deviceName] == undefined
            ) {
              eboard_device_site.value[index].color = "transparent";
              eboard_device_site.value[index].message = null;
              eboard_device_site.value[index].siteName = null;
              eboard_device_site.value[index].oper = null;
              eboard_device_site.value[index].operName = null;
              eboard_device_site.value[index].device_name = null;
            } else {
              if (all_device_data[data.deviceName] != undefined) {
                let status = all_device_data[data.deviceName]["status"];
                if (
                  all_device_data[data.deviceName]["auditMode"] &&
                  status == "S"
                ) {
                  status = "R";
                }
                if (status == "R") {
                  eboard_device_site.value[index].color = "#00ff00";
                } else if (status == "Q") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-warning-color)";
                } else if (status == "H") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-danger-color)";
                } else if (status == "S") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-stop-color)";
                } else if (status == "M") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-maintain-color)";
                } else if (status == "E") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-maintain-color)";
                } else if (status == "A") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-shunting-color)";
                } else if (status == "C") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-shunting-color)";
                } else if (status == "D") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-shunting-color)";
                } else if (status == "I") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-short-color)";
                } else {
                  eboard_device_site.value[index].color = "transparent";
                }
                eboard_device_site.value[index].message =
                  all_device_data[data.deviceName]["message"];
                eboard_device_site.value[index].site =
                  all_device_data[data.deviceName]["site"];
                eboard_device_site.value[index].siteName =
                  all_device_data[data.deviceName]["siteName"];
                eboard_device_site.value[index].oper =
                  all_device_data[data.deviceName]["oper"];
                eboard_device_site.value[index].operName =
                  all_device_data[data.deviceName]["operName"];
                eboard_device_site.value[index].device_name =
                  all_device_data[data.deviceName]["device_name"];
              } else if (package_data[data.deviceName] != undefined) {
                let status = package_data[data.deviceName]["status"];
                if (
                  package_data[data.deviceName]["auditMode"] &&
                  status == "S"
                ) {
                  status = "R";
                }
                if (status == "S") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-stop-color)";
                } else if (status == "R") {
                  eboard_device_site.value[index].color = "#00ff00";
                } else if (status == "Q") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-warning-color)";
                } else {
                  eboard_device_site.value[index].color = "transparent";
                }
                eboard_device_site.value[index].message =
                  package_data[data.deviceName]["message"];
                eboard_device_site.value[index].site =
                  package_data[data.deviceName]["site"];
                eboard_device_site.value[index].siteName =
                  package_data[data.deviceName]["siteName"];
                eboard_device_site.value[index].oper =
                  package_data[data.deviceName]["oper"];
                eboard_device_site.value[index].operName =
                  package_data[data.deviceName]["operName"];
                eboard_device_site.value[index].device_name =
                  package_data[data.deviceName]["device_name"];
              } else if (container_data[data.deviceName] != undefined) {
                let status = container_data[data.deviceName]["status"];
                if (
                  container_data[data.deviceName]["auditMode"] &&
                  status == "S"
                ) {
                  status = "R";
                }
                if (status == "S") {
                  eboard_device_site.value[index].color =
                    "var(--main-status-stop-color)";
                } else if (status == "R") {
                  eboard_device_site.value[index].color = "#00ff00";
                } else {
                  eboard_device_site.value[index].color = "transparent";
                }
                eboard_device_site.value[index].label =
                  container_data[data.deviceName]["label"];
                container_data[data.deviceName]["message"];
                eboard_device_site.value[index].message =
                  container_data[data.deviceName]["message"];
                eboard_device_site.value[index].site =
                  container_data[data.deviceName]["site"];
                eboard_device_site.value[index].siteName =
                  container_data[data.deviceName]["siteName"];
                eboard_device_site.value[index].oper =
                  container_data[data.deviceName]["oper"];
                eboard_device_site.value[index].operName =
                  container_data[data.deviceName]["operName"];
                eboard_device_site.value[index].device_name =
                  container_data[data.deviceName]["device_name"];
              }
            }
          });

          all_device_data = null;
        } else if (result.Response == "no access") {
          router.push("/login");
        }

        result_data = null;
        result = null;
        queryCounter.value++;
        getNowTime();
        setTimeout(function () {
          if (detail.value == true) {
            return;
          }
          getSiteData();
        }, 1000);
      });
    };
    //查詢目前稽核模式旗標
    const checkAuditModeStatus = () => {
      if (!canManageAuditMode.value) {
        return;
      }
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      params["methods"] = "GET";
      params["whichFunction"] = "CheckAuditModeStatus";
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;
        if (result.Response == "ok" && result.auditMode) {
          auditModeFlags.value = result.auditMode;
        }
      });
    };
    //切換稽核模式
    const toggleAuditMode = (siteKey) => {
      if (!canManageAuditMode.value) {
        return;
      }
      let enabled = !auditModeFlags.value[siteKey];
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      params["methods"] = "PATCH";
      params["whichFunction"] = "ToggleAuditMode";
      params["site"] = siteKey;
      params["enabled"] = enabled;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;
        if (result.Response == "ok" && result.auditMode) {
          auditModeFlags.value = result.auditMode;
        }
      });
    };
    // 設置提醒標題並顯示
    const setPopover = (deviceName) => {
      if (document.getElementById(deviceName).dataset.bsContent == "") {
        return;
      }
      popoverObj.value[deviceName] = new Popover(
        document.getElementById(deviceName)
      );
      popoverObj.value[deviceName].show();
    };
    // 清除提醒標題
    const killPopover = (deviceName) => {
      const elements = document.querySelectorAll(".popover.fade.home-popover");
      elements.forEach((element) => {
        element.remove();
      });
    };

    if (
      sideBarSelect.value.site != null &&
      sideBarSelect.value.site != undefined
    ) {
      siteArea.value = sideBarSelect.value.site;
    }
    //監聽使用者改變的選擇位置
    watch(sideBarSelect, (newValue) => {
      clearTimer();
      console.log(newValue.site);
      siteArea.value = newValue.site;
      siteName.value = newValue.siteName;
      detail.value = null;
    });

    // 監聽是否要看明細，若是總覽圖則初始化提醒標題，若否則執行場域資料查詢
    watch(detail, (newValue) => {
      console.log("detail----------:" + newValue);
      if (newValue == true) {
        killPopover();
      } else if (newValue == false) {
        getSiteMapData();
        initRealData();
      } else {
        detail.value = false;
      }
    });
    // 監聽視窗改變，更新機台位置
    watch(homeMap, (newValue) => {
      setTimeout(() => {
        homeMapSize(newValue);
      }, 500);
    });
    // 監聽側邊導覽列，更新機台位置
    watch(sideNavTrigger, () => {
      setTimeout(() => {
        homeMapSize(homeMap.value);
      }, 0);
    });
    // 紀錄查詢次數，超過1500次重新整理
    watch(queryCounter, (newValue) => {
      if (newValue > 1500) {
        window.location.reload();
      }
    });

    setTimeout(() => {
      const mesHomeDetail = sessionStorage.getItem("mes-home-detail");
      const mesHomeSiteArea = sessionStorage.getItem("mes-home-siteArea");
      const mesHomeSite = sessionStorage.getItem("mes-home-site");
      const mesHomeSiteName = sessionStorage.getItem("mes-home-siteName");
      const mesHomeOper = sessionStorage.getItem("mes-home-oper");
      const mesHomeOperName = sessionStorage.getItem("mes-home-operName");
      const mesHomeDeviceName = sessionStorage.getItem("mes-home-deviceName");

      sessionStorage.removeItem("mes-home-detail");
      sessionStorage.removeItem("mes-home-siteArea");
      sessionStorage.removeItem("mes-home-site");
      sessionStorage.removeItem("mes-home-siteName");
      sessionStorage.removeItem("mes-home-oper");
      sessionStorage.removeItem("mes-home-operName");
      sessionStorage.removeItem("mes-home-deviceName");

      if (mesHomeDetail != null) {
        detail.value = mesHomeDetail == "true" ? true : false;
      } else {
        detail.value = false;
      }
      if (mesHomeSiteArea != null && mesHomeSiteArea != "undefined") {
        siteArea.value = mesHomeSiteArea;
      }
      if (mesHomeSite != null && mesHomeSite != "undefined") {
        site.value = mesHomeSite;
      }
      if (mesHomeSiteName != null && mesHomeSiteName != "undefined") {
        siteName.value = mesHomeSiteName;
      }
      if (mesHomeOper != null && mesHomeOper != "undefined") {
        oper.value = mesHomeOper;
      }
      if (mesHomeOperName != null && mesHomeOperName != "undefined") {
        operName.value = mesHomeOperName;
      }
      if (mesHomeDeviceName != null && mesHomeDeviceName != "undefined") {
        deviceName.value = mesHomeDeviceName;
      }
    }, 0);

    onMounted(() => {
      // 監聽視窗改變，更新機台位置
      window.addEventListener("resize", function () {
        homeMapSize(homeMap.value);
      });
      checkAuditModeStatus();
    });

    provide("site", site);
    provide("siteName", siteName);
    provide("oper", oper);
    provide("operName", operName);
    provide("deviceName", deviceName);
    provide("detail", detail);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
      killPopover();
      clearTimer();
    });

    return {
      ...methods,
      nowTime,
      homeMap,
      siteArea,
      site,
      detail,
      eboardSite,
      eboard_device_site,
      deviceStatus,
      mapSize,
      changPage,
      setPopover,
      killPopover,
      canManageAuditMode,
      auditModeFlags,
      toggleAuditMode,
    };
  },
};
</script>

<style>
.mes-update-time {
  font-size: 1rem;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  font-size: 18px;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
}

.home-popover.popover {
  max-width: unset;
}

.home-popover>.popover-body {
  background-color: rgba(50, 50, 50, 0.7);
  color: var(--main-font-color);
}

.home-popover>.popover-arrow::after {
  border-top-color: rgba(50, 50, 50, 0.7);
  border-bottom-color: rgba(50, 50, 50, 0.7);
}
</style>
